import { apiClient, makeServicePlugin, BaseModel } from '@/api'

class PaypalPlan extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'PaypalPlan'
  // Define default properties here
  static instanceDefaults() {
    return {}
  }
}

const servicePath = 'paypal/plans'
const servicePlugin = makeServicePlugin({
  Model: PaypalPlan,
  service: apiClient.service(servicePath),
  servicePath: 'paypal:plans'
})

// Setup the client-side Feathers hooks.
apiClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin